import { useTheme } from "app/shared";
import { FC } from "react";
import styles from "./RisksOpportunities.module.scss";

interface RiskOpportunity {
  opportunity: string;
  risk: string;
}

interface RisksOpportunitiesProps {
  items: RiskOpportunity[];
}

const RisksOpportunities: FC<RisksOpportunitiesProps> = ({ items }) => {
  const { theme } = useTheme();

  const onlyOpportunities = items.filter((i) => i.opportunity.trim() !== "");
  const onlyRisks = items.filter((i) => i.risk.trim() !== "");

  return (
    <div
      className={`${styles.container} ${
        theme === "dark" ? styles.darkTheme : ""
      }`}
    >
      <h2 className={styles.title}>Risks & Opportunities</h2>

      <div className={styles.grid}>
        <div
          className={`${styles.column} ${
            theme === "dark" ? styles.darkTheme : ""
          }`}
        >
          <h3 className={styles.columnHeader}>Opportunities</h3>
          <ul className={styles.list}>
            {onlyOpportunities.map((item, index) => (
              <li key={`opp-${index}`} className={styles.listItem}>
                {item.opportunity}
              </li>
            ))}
          </ul>
        </div>

        <div
          className={`${styles.column} ${
            theme === "dark" ? styles.darkTheme : ""
          }`}
        >
          <h3 className={styles.columnHeader}>Risks</h3>
          <ul className={styles.list}>
            {onlyRisks.map((item, index) => (
              <li key={`risk-${index}`} className={styles.listItem}>
                {item.risk}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default RisksOpportunities;
